import { Garage } from '@/types/garage'
import { Link, Stack } from '@chakra-ui/react'
import NextLink from 'next/link'
import { GarageProfileMicro } from './GarageProfileMicro'

export const GarageHeader = (props: { garage: Garage }) => {
  const { garage } = props
  if (typeof garage?.public === 'undefined') return null
  if (!garage?.public) return null
  return (
    <Stack
      px={8}
      py={4}
      bgColor='gray.100'
      justify='space-between'
      align='center'
      direction={{ base: 'column', md: 'row' }}>
      <GarageProfileMicro garage={garage} />
      <Stack ml={{ md: 'auto' }} pt={3} spacing={6} direction='row'>
        <NextLink
          href={`/nation/garages/${garage.slug}`}
          passHref
          legacyBehavior>
          <Link _hover={{ color: 'red.400' }}>Projects</Link>
        </NextLink>
        {garage.is_business && (
          <NextLink
            href={`/nation/garages/${garage.slug}/contact`}
            passHref
            legacyBehavior>
            <Link _hover={{ color: 'red.400' }}>Contact</Link>
          </NextLink>
        )}
      </Stack>
    </Stack>
  )
}
